export default __webpack_public_path__ + "static/media/partnership-image-lg.b8fd49e4.png";